export default __webpack_public_path__ + "static/man-8e73bc5a162e2e3232ff1bd372ed17ef.webp";